var local_markers = [];
var mapFilters = [];
const DEFAULT_BOUNDS = {
	north: 59.3256059473492,
	south: 53.40066907684661,
	west: -8.864784507812509,
	east: 1.0119244765624913,
  };

const mapStyle =  [
    {
        featureType: 'all',
            elementType: 'all',
            stylers: [
                {
                    'invert_lightness': true
                },
                {
                    'saturation': 10
                },
                {
                    'lightness': 30
                },
                {
                    'gamma': 0.5
                },
                {
                    'hue': '#435158'
                }
            ]
    },

    {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [
            {
                'color': '#89c0eb'
            },
            {
                'visibility': 'simplified'
            }
        ]
    },
    {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [
            {
                color: '#023f58'
            }
        ]
    },
    {
        featureType: 'landscape.man_made',
        elementType: 'all',
        stylers: [
            {
                color: '#1d2d4d'
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#0e1726'
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'road',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#0e1726'
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#2b6775'
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#314a7d'
            }
        ]
    },
    {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6d9a97' }],

      },

    {
        featureType: 'poi',
        stylers: [{visibility: 'off'}]
    },
    {
        featureType: 'transit',
        elementType: 'labels.icon',
        stylers: [{visibility: 'off'}]
    }
];

const input  = document.getElementById("postcode");
var map;
//var placeService;

(function($) {

    function simpleMap(){
        const simpleMarker = $("#simplemap").find('.marker');
        const lat = Number(simpleMarker.attr('data-lat'));
        const lng = Number(simpleMarker.attr('data-lng'));

        const simpleMap = new google.maps.Map(document.getElementById("simplemap"), {
            zoom: 12,
            disableDefaultUI: true,
            center: {lat: lat , lng: lng},
            restriction: {
	 			latLngBounds: DEFAULT_BOUNDS,
	 			strictBounds: false,
	 		},
            //styles:mapStyle,
          });

          const latlng = new google.maps.LatLng(lat, lng);

          const icon = {
              url: simpleMarker.attr('data-icon')
          }

          var marker = new google.maps.Marker({
              position: latlng,
              map: simpleMap,
              icon: icon
          });

          marker.setVisible(true);
    }

	function intMap() {

        var markers = $("#show-gmap").find('.marker');

         map = new google.maps.Map(document.getElementById("show-gmap"), {
            zoom: 7,
            disableDefaultUI: true,
            center: {lat: 56.846850, lng: -3.959389},
            restriction: {
	 			latLngBounds: DEFAULT_BOUNDS,
	 			strictBounds: false,
	 		},
            styles:mapStyle,
            KeyboardShortcutsControl:false,
          });
         //direct load from file. possible to get by ajax and add by addGeoJson function
        //map.data.loadGeoJson(plugin_path+'/tca-garages/inc/stores.json', {idPropertyName: 'storeid'}, function(features){ } );
        // map.data.setStyle((feature) => {
        //     console.log(feature);
        //     return {
        //         icon: {
        //             url: asset_img_url+'/icon-material-location-yellow.png',
        //             scaledSize: new google.maps.Size(37, 52),
        //         }
        //     }
        // });


        map.markers = [];
        markers.each(function() {
			add_marker($(this), map);
		});

        //specify type:[] for more restriction about search type
        const options = {
            bounds: DEFAULT_BOUNDS,
            componentRestrictions: {country: 'gb'},
        };

        const autocomplete = new google.maps.places.Autocomplete(input, options);

        autocomplete.setFields(['address_components', 'geometry', 'name']);

        const originMarker = new google.maps.Marker({map: map});

        originMarker.setVisible(false);
        let originLocation = map.getCenter();

        autocomplete.addListener('place_changed', async () => {
            originMarker.setVisible(false);
            originLocation = map.getCenter();
            var place = autocomplete.getPlace();
            //console.log(place);

            if (!place.geometry) {
              // User entered the name of a Place that was not suggested and
              // pressed the Enter key, or the Place Details request failed.
             // window.alert('No address available for input: \'' + place.name + '\'');
              //return;
               // console.log(autocomplete.getFields());
                const service = new google.maps.places.AutocompleteService();
                const placeService = new google.maps.places.PlacesService(map);
                service.getQueryPredictions({ input: place.name }, function(predictions, status){
                    if (status == google.maps.places.PlacesServiceStatus.OK && predictions) {
                       // console.log(predictions[0].description);
                        placeService.getDetails({ placeId: predictions[0].place_id }, function(newPlace, serviceStatus) {
                            if(serviceStatus == google.maps.places.PlacesServiceStatus.OK){
                               // console.log(newPlace);
                                map.setCenter(newPlace.geometry.location);
                                map.setZoom(9);
                            }
                        });
                    }
                });

            }else{

                // Recenter the map to the selected address
                originLocation = place.geometry.location;
                map.setCenter(originLocation);
                map.setZoom(9);
            }

           // originMarker.setPosition(originLocation);
           // originMarker.setVisible(false);

            // Use the selected address as the origin to calculate distances
            // to each of the store locations
            //const rankedStores = await calculateDistances(map.data, originLocation); function removed
            //showStoresList(map.data, rankedStores); funciton removed
            //console.log(rankedStores);
            return;
          });

        map.addListener("zoom_changed", () => {
            //startDisplayingBig();
            let currentBounds = map.getBounds();
            changeGarageList(currentBounds, map);
        });
        map.addListener("dragend", () => {
            //startDisplayingBig();
            let currentBounds = map.getBounds();
            changeGarageList(currentBounds, map);
        });
        map.addListener("resize", () => {
            //startDisplayingBig();
            let currentBounds = map.getBounds();
            changeGarageList(currentBounds, map);
        });

    }

    function add_marker(singleMarker, newmap){

		var latlng = new google.maps.LatLng(singleMarker.attr('data-lat'), singleMarker.attr('data-lng'));

		var icon = {
			url: singleMarker.attr('data-icon')
		}

		var marker = new google.maps.Marker({
			position: latlng,
			map: newmap,
			icon: icon,
			service: singleMarker.attr('data-service'),
			garageid: singleMarker.attr('data-garageid'),
		});

        marker.setVisible(false);
        newmap.markers.push(marker);

        local_markers[singleMarker.attr('data-garageid')] =  marker.getPosition() ;

    }

    function changeGarageList(currentBounds, map){

        map.markers.forEach( (marker) => {
            marker.setVisible(true);
        });

        // let markers = map.markers;
        //     for (var i=0; i < markers.length; i++)
        //     {
        //         if (map.getBounds().contains(markers[i].getPosition()))
        //         {
        //             console.log('visible bounds');
        //         }
        //         else
        //         {
        //             console.log('non visible bounds');
        //         }
        //     }

    //console.log(currentBounds);
        // console.log(currentBounds.getNorthEast().lat());
        // console.log(currentBounds.getNorthEast().lng());
        // console.log(currentBounds.getSouthWest().lat());
        // console.log(currentBounds.getSouthWest().lng());



        let lng_bound= [currentBounds.getSouthWest().lng(), currentBounds.getNorthEast().lng()];
        let let_bound = [currentBounds.getSouthWest().lat(), currentBounds.getNorthEast().lat()];

        let postData = {
            "action": "tca_garages",
            "post_action": "get_garages_for_map",
            "filters": { 'let_bound': let_bound, 'lng_bound': lng_bound }
        }

        let request = $.post( ajaxurl, postData );
        request.done(function(response){
            const result = JSON.parse(response);
            if(result.success && result.data.garages){
                displayGarages(result.data);
            }
        });
    }

    function displayGarages(data){
			let list = '';

			if(data.garages.length > 0){
				data.garages.forEach((el, i) => {

					list += '<div class="item garage'+el.ID+'" data-garageid="garage'+el.ID+'" data-region="'+el.town+'">';
						list += '<div class="info"><a href="/?name='+el.name+'&town='+el.town+'&postcode='+el.postcode+'&id='+el.ID+'"><span class="title">'+el.name+'</span><span class="address">'+el.address+'</span><span class="city">'+el.town+',<span class="postcode"> '+el.postcode+'</span></span></a></div>';
						list += '<div class="contact"><div class="info-link"><a href="tel:'+el.phone+'" class="call"></a><a href="mailto:'+el.email+'" class="email"></a></div><div class="details"><a href="/?name='+el.name+'&town='+el.town+'&postcode='+el.postcode+'&id='+el.ID+'" class="details-link">Details</a></div></div>';
					list += '</div>';

				});
			}else{
				list = '<div class=""><div class="warning try-boarden-search">Please boarden your search. <span> Try again.</span> </div></div>';
			}

			$('#show-garages').html(list);
	}

    function changeDisplayToBig(){
        $('.v-pageHead--map').addClass('full-map');
    }

    function changeDisplayToSmall(){
        $('.v-pageHead--map').removeClass('full-map');
    }

	$(document).ready(function() {

        $('.v-pageHead--map').ready(function(){
            intMap();
        });

        $(document).on('submit','#search_form', function(e){
            e.preventDefault();
        });

        $(document).on('focus','#postcode', function(){
            changeDisplayToBig();

           // $('#mapModal').modal('show');
        });

        $(document).on('click', '#close-big-map', function(){
            changeDisplayToSmall();
        });

        $(document).on('click', '#search', function(){
            changeDisplayToBig();
            $('#postcode').focus();
        });

        $(document).on('click', '.try-boarden-search', function(){
            map.setZoom(6);
            $('#postcode').focus();
        });

        $('#show-garages').on('mouseenter mouseout', '.item', function(){
			let garageid = $(this).data('garageid');
			let marker_position = local_markers[garageid];

			map.markers.forEach( (marker, index) => {
				if(marker_position == marker.getPosition()){
					marker.setIcon(asset_img_url+'/icon-material-location-white.png');
				}else{
					marker.setIcon(asset_img_url+'/icon-material-location-yellow.png');
				}
			})

		});

        $('#map-filter input[type=checkbox]').on('change', function(){
			let selectedval = $(this).val();

			if($(this).is(':checked')){
				mapFilters.push(selectedval);
			}else{
				const index = mapFilters.indexOf(selectedval);
				if (index > -1) {
					mapFilters.splice(index, 1);
				}
			}

			filterMapByService();
		});


        function filterMapByService(){

			//console.log(local_markers);

			//local_markers['garage826'].setMap(map);

			// local_markers.forEach( (marker, index) => {
			// 	marker.setMap(map);
			// 	console.log(marker);
			// })

			//console.log(mapFilters);
			//console.log(local_markers);
			if(mapFilters.length > 0){
                //console.log('not empty');

				map.markers.forEach( (marker, index) => {
					//console.log(marker.service);
					let services = marker.service.split(',');
					var filtered_service = services.filter(function (el) {
						return el != '';
					});
					//console.log(filtered_service);

					let showInMap = true;
					mapFilters.forEach((element, index) => {
						let found = filtered_service.includes(element);

						if(!found){
							showInMap = false;
						}
					})

					//console.log(showInMap);
					if(!showInMap){
						marker.setMap(null);
						$('#show-garages .'+marker.garageid).slideUp();
					}else{
						marker.setMap(map);
						$('#show-garages .'+marker.garageid).slideDown();
					}
				})

			}else{
                //console.log('empty');
				map.markers.forEach( (marker, index) => {
					marker.setMap(map);
					$('#show-garages .item').slideDown();
				})
			}

			//map_center_when_filtering();
		}

        function map_center_when_filtering() {
            //console.log('centermap called');
            // //var bounds = //map.getBounds(); // google.maps.LatLngBounds();
            // var bounds = new google.maps.LatLngBounds();

            // $.each(map.markers, function(i, marker) {
            //     if (marker.visible) {
            //         var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            //         bounds.extend(latlng);
            //     }
            // });

            // map.fitBounds(bounds);
            //map.setCenter(bounds.getCenter());

        }

        $('.event-details').ready(function(){
			simpleMap();
		});





        // $('#mapModal').on('show.bs.modal', function (event) {
		// 	postcode = $('.v-pageHead--titlebar-content').find('.single-input').val();
		// 	var modal = $(this);
		// 	modal.find('#postcode').val(postcode);
		// 	intMap();
		// });

	});


})(jQuery);


//# sourceMappingURL=sourcemaps/main.js.map